const TPAG_VALIDOS = new Set([
  "01", "02", "03", "04", "05", "10", "11", "12", "13", "15", "16", "18", "19", "20", "90", "99",
]);

const REGRAS_DESCRICAO_TPAG = [
  { regex: /dinheiro|especie|esp[eé]cie|a\s*vista|avista/i, tpag: "01" },
  { regex: /cheque/i, tpag: "02" },
  { regex: /cart[aã]o\s*cr[eé]dito|cr[eé]dito/i, tpag: "03" },
  { regex: /cart[aã]o\s*d[eé]bito|d[eé]bito/i, tpag: "04" },
  { regex: /cr[eé]dito\s*loja|credi[aá]rio|fiado|a\s*prazo|prazo/i, tpag: "05" },
  { regex: /vale\s*alimenta/i, tpag: "10" },
  { regex: /vale\s*refei/i, tpag: "11" },
  { regex: /vale\s*presente/i, tpag: "12" },
  { regex: /vale\s*combust/i, tpag: "13" },
  { regex: /boleto/i, tpag: "15" },
  { regex: /dep[oó]sito\s*banc[aá]rio|dep[oó]sito/i, tpag: "16" },
  { regex: /transfer[eê]ncia\s*banc[aá]ria|transfer[eê]ncia|carteira\s*digital|ted\b|doc\b/i, tpag: "18" },
  { regex: /pix|pagamento\s*instant[aâ]neo/i, tpag: "20" },
];

function _normalizarCodigo(codigo) {
  if (codigo == null || String(codigo).trim() === "") return null;
  const normalizado = String(codigo).trim().padStart(2, "0");
  return TPAG_VALIDOS.has(normalizado) ? normalizado : null;
}

function _descricaoPagamento(pagamento = {}) {
  return String(
    pagamento.descricao ??
      pagamento.description ??
      pagamento.nome ??
      pagamento.name ??
      ""
  ).trim();
}

export function resolverTpagPagamento(pagamento = {}) {
  const codigoExplicito =
    pagamento.tpag ??
    pagamento.tPag ??
    pagamento.tp_pag ??
    pagamento.codigo_nfe ??
    pagamento.codigo_fiscal ??
    null;

  const tpagExplicito = _normalizarCodigo(codigoExplicito);
  if (tpagExplicito) return tpagExplicito;

  const descricao = _descricaoPagamento(pagamento).toLowerCase();
  for (const { regex, tpag } of REGRAS_DESCRICAO_TPAG) {
    if (regex.test(descricao)) return tpag;
  }

  return "99";
}

export function resolverXPagPagamento(pagamento = {}) {
  const xPag = String(pagamento.xPag ?? pagamento.xpag ?? _descricaoPagamento(pagamento)).trim();
  return xPag || "Outros";
}

export function normalizarPagamentoFiscal(pagamento = {}) {
  const tpag = resolverTpagPagamento(pagamento);
  const normalizado = {
    ...pagamento,
    tpag,
  };

  if (tpag === "99") {
    normalizado.xPag = resolverXPagPagamento(pagamento);
  }

  return normalizado;
}
